<template>
  <v-card class="ml-2 mr-2" height="100%">
    <h2 class="text-xs-center">{{$t('dashboard.alerts.title')}}</h2>
    <v-layout column>
      <div class="text-xs-center">
        <v-icon class="real-big-icon">alarm</v-icon>
      </div>
      <v-container fluid grid-list-md style="font-size: 20px;">
        <v-layout wrap row class="pointer mt-2 mb-5">
          <v-flex xs4 class="text-xs-right text-bold" @click="clickedYesterday">
            {{dashboardAlerts.yesterday}}
          </v-flex>
          <v-flex xs6 offset-xs1 @click="clickedYesterday">
            {{$t('dashboard.alerts.yesterday')}}
          </v-flex>
          <v-flex xs4 class="text-xs-right text-bold" @click="clickedLastWeek">
            {{dashboardAlerts.lastWeek}}
          </v-flex>
          <v-flex xs6 offset-xs1 @click="clickedLastWeek">
            {{$t('dashboard.alerts.last_week')}}
          </v-flex>
          <v-flex xs4 class="text-xs-right text-bold" @click="clickedLastMonth">
            {{dashboardAlerts.lastFourWeeks}}
          </v-flex>
          <v-flex xs6 offset-xs1 @click="clickedLastMonth">
            {{$t('dashboard.alerts.last_four_weeks')}}
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-card>
</template>

<script>
  import { EMPTY_INTERACTIONS_LIST } from '../../store/mutation-types'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import moment from 'moment-es6'
  import { GET_ALERT_INTERACTIONS, GET_DASHBOARD_ALERTS_COUNT } from '../../store/action-types'

  export default {
    name: 'dashboard-alerts',
    props: [],
    mixins: [],
    data () {
      return {}
    },
    methods: {
      calculateDateRange (startRange, startUnit, endRange, endUnit) {
        return {
          startDate: moment().subtract(startRange, startUnit).format('YYYY-MM-DD'),
          endDate: moment().subtract(endRange, endUnit).format('YYYY-MM-DD')
        }
      },
      clickedYesterday () {
        this.dateRange = this.calculateDateRange(1, 'd', 1, 'd')
        this.navigateToInteractions()
      },
      clickedLastWeek () {
        this.dateRange = this.calculateDateRange(7, 'd', 1, 'd')
        this.navigateToInteractions()
      },
      clickedLastMonth () {
        this.dateRange = this.calculateDateRange(28, 'd', 1, 'd')
        this.navigateToInteractions()
      },
      navigateToInteractions () {
        this.getInteractions(this.dateRange)
        this.$router.push({name: 'Interactions'})
      },
      ...mapMutations({
        emptyInteractionsList: EMPTY_INTERACTIONS_LIST
      }),
      ...mapActions({
        getInteractions: GET_ALERT_INTERACTIONS,
        getDashboardAlerts: GET_DASHBOARD_ALERTS_COUNT
      })
    },
    computed: {
      ...mapState({
        dashboardAlerts: state => state.dashboard.dashboardAlerts
      })
    },
    watch: {},
    mounted () {
      this.getDashboardAlerts()
    }
  }
</script>

<style scoped>
  .real-big-icon {
    font-size: 112px;
  }
  .text-bold {
    font-weight: bolder;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardAlerts.vue